// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlignCenterOutlinedSvg from "@fishx/icons-svg/es/asn/AlignCenterOutlined";
import FishxIcon from '../components/FishxIcon';

var AlignCenterOutlined = function AlignCenterOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlignCenterOutlinedSvg
  }));
};

AlignCenterOutlined.displayName = 'AlignCenterOutlined';
export default React.forwardRef(AlignCenterOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AlignCenterOutlined.js
// module id = 1960
// module chunks = 0